import {normalize} from 'normalizr';
import {getEndpoint, getHeaders} from '../../helpers/endpoint';
import {matcheschema, matchListSchema} from '../../schemas/match';
import {receiveEntities} from '../entities';

export const REQUEST_FETCH_MATCH = 'REQUEST_FETCH_MATCH';
export const SUCCESS_FETCH_MATCH = 'SUCCESS_FETCH_MATCH';
export const FAIL_FETCH_MATCH = 'FAIL_FETCH_MATCH';

export const fetchMatch = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_MATCH, payload, scope});

    fetch(getEndpoint('fetchMatch', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_MATCH,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successFetchMatch(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_MATCH) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchMatch(response, payload, scope) {
  return dispatch => {
    const normalized = normalize(response, matcheschema);

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_MATCH,
      receivedAt: Date.now(),
      id: normalized.result,
      payload,
      scope,
    });
  };
}

export const REQUEST_FETCH_MATCHES = 'REQUEST_FETCH_MATCHES';
export const SUCCESS_FETCH_MATCHES = 'SUCCESS_FETCH_MATCHES';
export const FAIL_FETCH_MATCHES = 'FAIL_FETCH_MATCHES';

export const fetchMatches = (payload, scope) => {
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_MATCHES, payload, scope});

    fetch(getEndpoint('fetchMatches', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error)
          dispatch({
            type: FAIL_FETCH_MATCHES,
            error: data.error,
            payload,
            scope,
          });
        else dispatch(successFetchMatches(data, payload, scope));
      })
      .catch((error, type = FAIL_FETCH_MATCHES) => {
        dispatch({type, error, payload, scope});
      });
  };
};

function successFetchMatches(response, payload, scope) {
  return dispatch => {
    const normalized = normalize(
      response.championshipGameWeekMatchesDetails,
      matchListSchema,
    );

    dispatch(receiveEntities(normalized.entities));
    dispatch({
      type: SUCCESS_FETCH_MATCHES,
      receivedAt: Date.now(),
      ids: normalized.result,
      day: payload.day,
      payload,
      scope,
    });
  };
}

export const REQUEST_FETCH_MATCH_DAYS = 'REQUEST_FETCH_MATCH_DAYS';
export const SUCCESS_FETCH_MATCH_DAYS = 'SUCCESS_FETCH_MATCH_DAYS';
export const FAIL_FETCH_MATCH_DAYS = 'FAIL_FETCH_MATCH_DAYS';

export const fetchMatchDays = (payload, callbacks) => {
  const {onError, onRequest, onSuccess} = callbacks;
  return (dispatch, getState) => {
    dispatch({type: REQUEST_FETCH_MATCH_DAYS, payload});
    if (onRequest) onRequest(payload);

    fetch(getEndpoint('fetchMatchDays', payload), {
      method: 'GET',
      headers: getHeaders(getState().authentication),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) dispatch({type: FAIL_FETCH_MATCH_DAYS});
        else dispatch({type: SUCCESS_FETCH_MATCH_DAYS, data});

        if (onSuccess) onSuccess(data, payload);
      })
      .catch((error, type = FAIL_FETCH_MATCH_DAYS) => {
        if (onError) onError(error, type);
        dispatch({type, error});
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/entities/match.js